<template>
  <div>
    <div
      style="background-color: white; padding: 20px 20px; text-align: justify"
    >
      <span style="font-size: 20px; font-weight: bolder"
        >The comparison of perturbation-induced transcriptional phenotypes among
        different genes allows for the inference of the function of a novel gene
        based on genes with known functions.</span
      >
      <!-- <div style="margin-left: 15px">
        1. The histogram presented here illustrates the distribution of
        perturbation clusters across all datasets contained in PerturbDB ;
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster1.png"
        />
      </div> -->
      <div style="margin-left: 15px; font-size: 18px">
        1. The table displays the number of genes within each perturbation
        cluster. Users can enter the gene name of interest in the search box to
        determine whether it is assigned to a perturbation cluster.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster2.png"
        />
      </div>
      <span style="font-size: 20px; font-weight: bolder">
        Let's input a gene name, "<i style="color: blue">SIRT7</i>", for
        example:
      </span>
      <div style="margin-left: 15px; font-size: 18px">
        2. It is recognized to be involved in the formation of 3 perturbation
        cluster. Clicking the dropdown button, users can get other genes that
        collectively constitute the perturbation cluster.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster3.png"
        />
      </div>
      <div style="margin-left: 15px; font-size: 18px">
        3. Clicking on "PC00038" provides detailed information about the
        specific perturbation cluster. The Members Table contains a list of
        members within the perturbation cluster. This table presents relevant
        gene information, with a particular emphasis on marking whether a gene
        is a new cluster gene in the last column. We believe that the new gene
        likely shares similar functions or can form a subcomplex with
        known-members.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster4.png"
        />
      </div>
      <div style="margin-left: 15px; font-size: 18px">
        4. The enriched annotation highlights the pathways and complexes
        associated with all genes within the cluster. The top 10 terms from the
        enrichment analysis are considered to display.
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster5.png"
        />
      </div>
      <div style="text-align: center">
        <img
          width="60%"
          height="60%"
          src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster6.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
